/**
 * Validates and cleans a characters array, removing nulls, undefined, and invalid values
 * @param {Array} characters - The characters array to validate
 * @returns {Array} - Cleaned array with only valid character IDs
 */
export function validateCharactersArray(characters) {
  if (!Array.isArray(characters)) {
    return [];
  }

  return characters.filter((characterId) => {
    if (characterId === null || characterId === undefined) {
      return false;
    }
    if (typeof characterId !== "string") {
      return false;
    }
    return characterId.trim() !== "";
  });
}

export default validateCharactersArray;
